module.exports = __webpack_public_path__ + "static/media/Vector_6.e052cea6.png";